<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 32 32"
>
  <path
    fill="#fff"
    d="M22.697 26.613a103.703 103.703 0 0 0-2.604-4.673c1.58-5.622 4.047-12.05 9.778-19.961-5.708 3.798-9.955 9.525-12.87 15.198C13.369 12.09 8.891 7.58 3.134 5.086c4.515 5.099 8.899 11.303 11.741 16.769a50.685 50.685 0 0 0-1.594 4.629c-.723-5.318-4.674-10.701-8.725-10.857 4.268 4.285 7.064 11.032 4.683 14.669h3.134a24.75 24.75 0 0 0-.07.405h5.563l.12-.45c.021.147.041.292.056.434h6.73a62.2 62.2 0 0 0-.182-.366h2.794c-1.477-4.18-.675-9.497.718-15.59-3.182 2.868-4.782 7.131-5.404 11.883zM2.631 20.772c3.101 4.734 3.61 7.309 2.395 9.51h3.948c-.766-4.212-1.84-6.802-6.343-9.51z"
  />
</svg>
